<input type="number" class="form-control" bkInput [(ngModel)]="npi_no" (change)="updateNPINumber($event)" pattern="^\d{10}$" />